import { PlayerBullet, EnemyBullet, BulletHell } from './Bullet';
import { PenetratingBullet } from './SpecialWeapons';
import { TrailManager } from './TrailEffect';

export class BulletManager {
  private playerBullets: (PlayerBullet | PenetratingBullet)[] = [];
  private enemyBullets: (EnemyBullet | BulletHell)[] = [];
  private trailManager: TrailManager | null = null;

  setTrailManager(trailManager: TrailManager): void {
    this.trailManager = trailManager;
  }

  update(deltaTime: number): void {
    this.playerBullets.forEach(bullet => {
      bullet.update(deltaTime);
      if (this.trailManager && bullet.alive) {
        this.trailManager.addTrail(bullet.id, bullet.position.x + bullet.width / 2, bullet.position.y + bullet.height, '#ffff00', 3);
      }
    });
    this.enemyBullets.forEach(bullet => bullet.update(deltaTime));

    const removedBullets = this.playerBullets.filter(bullet => !bullet.alive);
    removedBullets.forEach(bullet => {
      if (this.trailManager) {
        this.trailManager.removeTrail(bullet.id);
      }
    });

    this.playerBullets = this.playerBullets.filter(bullet => bullet.alive);
    this.enemyBullets = this.enemyBullets.filter(bullet => bullet.alive);
  }

  render(ctx: CanvasRenderingContext2D): void {
    this.playerBullets.forEach(bullet => bullet.render(ctx));
    this.enemyBullets.forEach(bullet => bullet.render(ctx));
  }

  addPlayerBullet(bullet: PlayerBullet | PenetratingBullet): void {
    this.playerBullets.push(bullet);
  }

  addEnemyBullet(bullet: EnemyBullet | BulletHell): void {
    this.enemyBullets.push(bullet);
  }

  getPlayerBullets(): (PlayerBullet | PenetratingBullet)[] {
    return this.playerBullets;
  }

  getEnemyBullets(): (EnemyBullet | BulletHell)[] {
    return this.enemyBullets;
  }

  clear(): void {
    this.playerBullets = [];
    this.enemyBullets = [];
  }

  clearPlayerBullets(): void {
    if (this.trailManager) {
      this.playerBullets.forEach(bullet => {
        this.trailManager!.removeTrail(bullet.id);
      });
    }
    this.playerBullets = [];
  }

  clearEnemyBullets(): void {
    this.enemyBullets = [];
  }
}